import { AUTH_VIEW } from 'apps/auth/constants/ServerConstants';
import ChangePasswordPage from 'apps/auth/pages/ChangePasswordPage';
import ProfileAmlLevelDocsPage from 'apps/auth/pages/profile/aml/level/ProfileAmlLevelDocsPage';
import { ProfileAmlLevelInfoPage } from 'apps/auth/pages/profile/aml/ProfileAmlLevelInfoPage';
import ProfileAmlLimitsPage from 'apps/auth/pages/profile/aml/ProfileAmlLimitsPage';
import AuthBonusPage from 'apps/auth/pages/profile/bonus/AuthBonusPage';
import ChangeEmailPage from 'apps/auth/pages/profile/change/ChangeEmailPage';
import ChangePhoneNumberPage from 'apps/auth/pages/profile/change/ChangePhoneNumberPage';
import ProfileGAAmlLevelDocsPage from 'apps/auth/pages/profile/ga/aml/level/ProfileGAAmlLevelDocsPage';
import ProfileGAAmlLevelInfoPage from 'apps/auth/pages/profile/ga/aml/level/ProfileGAAmlLevelInfoPage';
import ProfileGALimitInfoPage from 'apps/auth/pages/profile/ga/limit/ProfileGALimitInfoPage';
import ProfileGTAmlLevelDocsPage from 'apps/auth/pages/profile/gt/aml/level/ProfileGTAmlLevelDocsPage';
import ProfileGTAmlLevelInfoPage from 'apps/auth/pages/profile/gt/aml/level/ProfileGTAmlLevelInfoPage';
import InviteFriendsPage from 'apps/auth/pages/profile/inviteFriend/InviteFriendsPage';
import KycInvalidPage from 'apps/auth/pages/profile/KycInvalidPage';
import ProfileLibreLimitInfoPage from 'apps/auth/pages/profile/limit/libre/ProfileLibreLimitInfoPage';
import ProfileLimitInfoPage from 'apps/auth/pages/profile/limit/ProfileLimitInfoPage';
import PaysendPlusChangePlanPage from 'apps/auth/pages/profile/paysendPlus/PaysendPlusChangePlanPage';
import PaysendPlusDashboardPage from 'apps/auth/pages/profile/paysendPlus/PaysendPlusDashboardPage';
import PaysendPlusEmployeeSubscribePage from 'apps/auth/pages/profile/paysendPlus/PaysendPlusEmployeeSubscribePage';
import PaysendPlusSubscribePage from 'apps/auth/pages/profile/paysendPlus/PaysendPlusSubscribePage';
import PaysendPlusUpdatePaymentMethodPage from 'apps/auth/pages/profile/paysendPlus/PaysendPlusUpdatePaymentMethodPage';
import PlusComplexStatusPage from 'apps/auth/pages/profile/paysendPlus/PlusComplexStatusPage';
import PlusUnsubscribePage from 'apps/auth/pages/profile/paysendPlus/PlusUnsubscribePage';
import ProfileDownloadPage from 'apps/auth/pages/profile/paysendPlus/ProfileDownloadPage';
import PhoneNumberUpdatedPage from 'apps/auth/pages/profile/phone/PhoneNumberUpdatedPage';
import ProfileAppearancePage from 'apps/auth/pages/profile/ProfileAppearancePage';
import ProfileLimitsPage from 'apps/auth/pages/profile/ProfileLimitsPage';
import ProfileNotificationsPage from 'apps/auth/pages/profile/ProfileNotificationsPage';
import ProfileSettingsPage from 'apps/auth/pages/profile/ProfileSettingsPage';
import RegistrationFinishPage from 'apps/auth/pages/profile/registration/RegistrationFinishPage';
import ProfileAdditionalFieldsPage from 'apps/auth/pages/profile/updateFields/ProfileAdditionalFieldsPage';
import ProfileAddPersonalInfoPage from 'apps/auth/pages/profile/updateFields/ProfileAddPersonalInfoPage';
import ProfileFieldsEditNewApi from 'apps/auth/pages/profile/updateFields/ProfileFieldsEditNewApi';
import ProfileFieldsPage from 'apps/auth/pages/profile/updateFields/ProfileFieldsPage';
import ProfileFieldsUpdatePage from 'apps/auth/pages/profile/updateFields/ProfileFieldsUpdatePage';
import UpdateLegacyInfoPage from 'apps/auth/pages/profile/UpdateLegacyInfoPage';
import ProfilePage from 'apps/auth/pages/ProfilePage';
import DeactivateAccountDisclaimerPage from 'apps/auth/pages/security/deactivate/DeactivateAccountDisclaimerPage';
import SecurityPage from 'apps/auth/pages/SecurityPage';
import SettingsPage from 'apps/auth/pages/SettingsPage';

const authProfile = [
    {
        path: ['/auth/profile/update-legacy-info', '/auth/profile/update-israel-legacy-info'],
        component: UpdateLegacyInfoPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/kyc-invalid',
        component: KycInvalidPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/ga/aml/level/:level/info',
        component: ProfileGAAmlLevelInfoPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/gt/aml/level/:level/info',
        component: ProfileGTAmlLevelInfoPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/aml/level/:level/info',
        component: ProfileAmlLevelInfoPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/ga/aml/level/:level/docs',
        component: ProfileGAAmlLevelDocsPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/gt/aml/level/:level/docs',
        component: ProfileGTAmlLevelDocsPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/aml/level/:level/docs',
        component: ProfileAmlLevelDocsPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/aml/levels',
        component: ProfileAmlLimitsPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/change/phone',
        component: ChangePhoneNumberPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/change/email',
        component: ChangeEmailPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/phone/updated',
        component: PhoneNumberUpdatedPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/limit/info/:current',
        component: ProfileLimitInfoPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/libre/limit/info',
        component: ProfileLibreLimitInfoPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            isGA: true,
        },
    },
    {
        path: '/auth/profile/ga/limit/info/:current',
        component: ProfileGALimitInfoPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            isGA: true,
        },
    },
    {
        path: ['/auth/profile/limits', '/auth/profile/ga/limits'],
        component: ProfileLimitsPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/fields/update',
        component: ProfileFieldsUpdatePage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/fields',
        component: ProfileFieldsPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/edit/personal/info',
        component: ProfileFieldsEditNewApi,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/fields/screens',
        component: ProfileAddPersonalInfoPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/notifications',
        component: ProfileNotificationsPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/settings',
        component: ProfileSettingsPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/appearance',
        exact: true,
        component: ProfileAppearancePage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/bonus',
        component: AuthBonusPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/plus/main.page',
        component: PaysendPlusDashboardPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/plus/unsubscribe.screen',
        component: PlusUnsubscribePage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: ['/auth/plus/payment/methods/list'],
        component: PaysendPlusSubscribePage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: ['/auth/plus/employee/subscribe'],
        component: PaysendPlusEmployeeSubscribePage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: ['/auth/plus/subscribe/method/update'],
        component: PaysendPlusUpdatePaymentMethodPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: ['/auth/plus/subscribe/plan/update'],
        component: PaysendPlusChangePlanPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: ['/auth/plus/pay/subscription/status'],
        component: PlusComplexStatusPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/download',
        component: ProfileDownloadPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile',
        exact: true,
        component: ProfilePage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/security/deactivate/account',
        component: DeactivateAccountDisclaimerPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/security',
        exact: true,
        component: SecurityPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/settings',
        exact: true,
        component: SettingsPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/changepassword',
        component: ChangePasswordPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/invite-friends',
        component: InviteFriendsPage,
        exact: true,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/registration/finish',
        component: RegistrationFinishPage,
        exact: true,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: '/auth/profile/additional/fields/screen',
        component: ProfileAdditionalFieldsPage,
        exact: true,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
];

export default authProfile;
